import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { SiteVideoManager } from '@/components/admin/SiteVideoManager';

export default function AdminSiteVideos() {
  return (
    <AdminLayout>
      {/* Header */}
      <div className="p-6 bg-gradient-to-r from-blue-900/20 to-purple-900/20 border-b border-white/10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold mb-2">Site Video Management</h1>
              <p className="text-gray-400">Manage promotional videos for homepage and sales pages</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          <SiteVideoManager />
        </div>
      </div>
    </AdminLayout>
  );
}
